import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AppState } from 'src/app/state/app-state';

@Injectable()
export class BootstrapService {
  constructor(private store: Store<AppState>) {}

  initSession(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let initializersSubscription: Subscription;

      initializersSubscription = this.store
        .select('bootstrapSession')
        .subscribe((initialized: boolean) => {
          if (initialized) {
            if (initializersSubscription) {
              initializersSubscription.unsubscribe();
            }

            resolve();
          }
        });
    });
  }
}
